export default "__VITE_ASSET__kAZndA2g__"